import axios from '../../axios';
import { useQuery } from '@tanstack/react-query';
import type { TSpaceBase, TError } from '@onesource/schemas';
import { ENTITY } from '../entity';

/**
 * Query key for fetching user's accessible parent spaces - non-hook version
 */
export const getMySpacesQueryKey = () => [ENTITY, 'my-spaces'];

/**
 * Query key for fetching user's accessible parent spaces
 */
export const useGetMySpacesQueryKey = () => getMySpacesQueryKey();

/**
 * Hook to fetch all parent spaces accessible to the current user
 * These are the top-level spaces shown in the space list
 */
export const useGetMySpaces = () => {
  return useQuery<TSpaceBase[], TError>({
    queryKey: useGetMySpacesQueryKey(),
    queryFn: async () => {
      const res = await axios.get<TSpaceBase[]>('/community-hub/spaces');
      return res.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
};
